import React from "react";
import styled, { keyframes } from "styled-components";
import config from "../config/app.json";
import useCheckIsMobile from "../hooks/useCheckIsMobile";

const webUrl = config["TEMPLATEURLS"][config["TEMPLATEURLS"]["current"]];
const slideInFromLeft = keyframes`
0% {
    transform: translateX(100%) translateY(100%);
  }
  100% {
    transform: translateX(0) translateY(0);
  }
`;

const Wrapper = styled.div`
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  align-items: center;
  justify-content: center;
  display: flex;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1;
  height: 100vh;
`;
const FeatureDiv = styled.div`
  display: flex;
  justify-content: center;
  position: relative;
  animation: 0.25s ease-out 0s 1 ${slideInFromLeft};
`;
const CloseBtn = styled.div`
  width: 20px;
  height: 20px;
  position: absolute;
  background: rgba(0, 0, 0, 0.2);
  border-radius: 50%;
  right: 5px;
  top: 5px;
  cursor: pointer;
`;
const BgDiv = styled.div`
  width: 100%;
  height: 100%;
  overflow: hidden;
  background: #2f1a75;
  border-radius: 10px;
`;
const ContentDiv = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
`;
const ContentWrap = styled.div`
  padding: 40px;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
`;
const TCont = styled.div`
  color: #ffffff;
  font-size: 18px;
  display: flex;
  flex-direction: column;
  gap: 25px;
  align-items: center;
  justify-content: center;
  text-align: center;
  font-family: PTSans-Bold;
  line-height: 1.2;
  margin-top: 30px;
`;
const FooterDiv = styled.div`
  margin-top: auto;
  display: flex;
  width: 100%;
`;
const SButton = styled.a`
  background: transparent linear-gradient(99deg, #f67062 0%, #fc5296 100%) 0% 0%
    no-repeat padding-box;
  box-shadow: 0px 0px 6px #0000005f;
  border-radius: 8px;
  color: #ffffff;
  padding: 18px;
  text-decoration: none;
  font-size: 18px;
  font-family: PTSans-Bold;
  text-align: center;
  width: 100%;
`;
const LCont = styled.div`
  & > img {
    margin: auto;
    width: 150px;
  }
`;
const SplText = styled.div`
  background: transparent linear-gradient(90deg, #f67062 0%, #fc5296 100%) 0% 0%
    no-repeat padding-box;
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
`;
const Btxt = styled.div`
  text-align: center;
  font-size: 24px;
  line-height: 1.3;
`;
const Stxt = styled.div`
  font-family: PTSans-Regular;
  font-size: 16px;
  line-height: 1.4;
`;
export default function NewFeatureAlert(props) {
  const { isMobileWidth, size } = useCheckIsMobile();

  let stageWidth = isMobileWidth ? size - 30 : 445;
  let stageHeight = 430;
  const top = isMobileWidth ? 50 : 0;
  return (
    <Wrapper>
      <FeatureDiv
        style={{
          width: stageWidth + "px",
          height: stageHeight + "px",
          top: top + "px",
        }}
      >
        <BgDiv>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="192"
            height="164"
            viewBox="0 0 192 164"
          >
            <defs>
              <linearGradient
                id="linear-gradient"
                x2="1"
                y2="1"
                gradientUnits="objectBoundingBox"
              >
                <stop offset="0" stop-color="#a567ff" />
                <stop offset="1" stop-color="#ff6599" />
              </linearGradient>
              <clipPath id="clip-path">
                <path
                  id="Rectangle_18691"
                  data-name="Rectangle 18691"
                  d="M12,0H192a0,0,0,0,1,0,0V164a0,0,0,0,1,0,0H12A12,12,0,0,1,0,152V12A12,12,0,0,1,12,0Z"
                  transform="translate(-11495 -5341)"
                  fill="url(#linear-gradient)"
                />
              </clipPath>
            </defs>
            <g
              id="Group_63894"
              data-name="Group 63894"
              transform="translate(11495 5341)"
              clip-path="url(#clip-path)"
            >
              <path
                id="Path_84967"
                data-name="Path 84967"
                d="M0,0H946"
                transform="translate(-11494.5 -5331.5)"
                fill="none"
                stroke="#2a1767"
                strokeLineCap="round"
                strokeWidth="2"
                strokeDashArray="0.2 10"
                opacity="0.143"
              />
              <path
                id="Path_84968"
                data-name="Path 84968"
                d="M0,0H946"
                transform="translate(-11494.5 -5232)"
                fill="none"
                stroke="#2a1767"
                strokeLineCap="round"
                strokeWidth="2"
                strokeDashArray="0.2 10"
                opacity="0.143"
              />
              <g
                id="Group_63893"
                data-name="Group 63893"
                transform="translate(-12631.203 -5504.706)"
              >
                <g
                  id="Group_63892"
                  data-name="Group 63892"
                  transform="translate(1108.772 138.817)"
                >
                  <path
                    id="Union_16"
                    data-name="Union 16"
                    d="M17.333,93.074l.138-5.781A20,20,0,0,1,0,67.452V20A20,20,0,0,1,20,0H92.481a20,20,0,0,1,20,20V67.452a20,20,0,0,1-20,20H42.438L25.71,98.126a5.283,5.283,0,0,1-2.861.854A5.646,5.646,0,0,1,17.333,93.074Z"
                    transform="translate(0 0)"
                    fill="#1c1246"
                    opacity="0.26"
                  />
                  <g
                    id="Union_17"
                    data-name="Union 17"
                    transform="translate(15.95 8.843)"
                    fill="none"
                  >
                    <path
                      d="M17.333,93.074l.138-5.781A20,20,0,0,1,0,67.452V20A20,20,0,0,1,20,0H92.481a20,20,0,0,1,20,20V67.452a20,20,0,0,1-20,20H42.438L25.71,98.126a5.283,5.283,0,0,1-2.861.854A5.646,5.646,0,0,1,17.333,93.074Z"
                      stroke="none"
                    />
                    <path
                      d="M 25.43702125549316 88.81053924560547 L 40.10320281982422 79.45210266113281 L 92.48131561279297 79.45210266113281 C 99.09800720214844 79.45210266113281 104.4810943603516 74.06901550292969 104.4810943603516 67.45229339599609 L 104.4810943603516 19.99979400634766 C 104.4810943603516 13.38309955596924 99.09800720214844 8.000012397766113 92.48131561279297 8.000012397766113 L 19.99979019165039 8.000012397766113 C 13.38309478759766 8.000012397766113 8.000007629394531 13.38309955596924 8.000007629394531 19.99979400634766 L 8.000007629394531 67.45229339599609 C 8.000007629394531 73.48535919189453 12.50226879119873 78.60311889648438 18.47268104553223 79.35666656494141 L 25.64085578918457 80.26136016845703 L 25.43702125549316 88.81053924560547 M 22.84961700439453 98.97979736328125 C 19.93131256103516 98.9798583984375 17.2511157989502 96.50392913818359 17.33309364318848 93.07440185546875 L 17.47092056274414 87.29368591308594 C 7.619551181793213 86.05031585693359 7.516612186009297e-06 77.64112091064453 7.516612186009297e-06 67.45229339599609 L 7.516612186009297e-06 19.99979400634766 C 7.516612186009297e-06 8.954099655151367 8.954094886779785 1.234104365721578e-05 19.99979019165039 1.234104365721578e-05 L 92.48131561279297 1.234104365721578e-05 C 103.5270080566406 1.234104365721578e-05 112.4810943603516 8.954099655151367 112.4810943603516 19.99979400634766 L 112.4810943603516 67.45229339599609 C 112.4810943603516 78.49800872802734 103.5270080566406 87.45210266113281 92.48131561279297 87.45210266113281 L 42.43815994262695 87.45210266113281 L 25.71031188964844 98.1260986328125 C 24.79061698913574 98.71314239501953 23.80724716186523 98.97977447509766 22.84961700439453 98.97979736328125 Z"
                      stroke="none"
                      fill="#36219b"
                    />
                  </g>
                  <g
                    id="Rectangle_18690"
                    data-name="Rectangle 18690"
                    transform="translate(33.008 32.269)"
                    fill="none"
                    stroke="#36219b"
                    strokeWidth="8"
                  >
                    <rect width="39.982" height="39.982" rx="6" stroke="none" />
                    <rect
                      x="4"
                      y="4"
                      width="31.982"
                      height="31.982"
                      rx="2"
                      fill="none"
                    />
                  </g>
                  <path
                    id="Path_84971"
                    data-name="Path 84971"
                    d="M0,0H28.834"
                    transform="translate(82.082 37.232)"
                    fill="none"
                    stroke="#36219b"
                    strokeLineCap="round"
                    strokeWidth="8"
                  />
                  <line
                    id="Line_3252"
                    data-name="Line 3252"
                    x2="17.041"
                    transform="translate(82.632 67.253)"
                    fill="none"
                    stroke="#36219b"
                    strokeLineCap="round"
                    strokeWidth="8"
                  />
                  <line
                    id="Line_3253"
                    data-name="Line 3253"
                    x2="28.834"
                    transform="translate(82.082 52.242)"
                    fill="none"
                    stroke="#36219b"
                    strokeLineCap="round"
                    strokeWidth="8"
                  />
                </g>
                <ellipse
                  id="Ellipse_5922"
                  data-name="Ellipse 5922"
                  cx="3.611"
                  cy="3.611"
                  rx="3.611"
                  ry="3.611"
                  transform="translate(1163.489 180.739)"
                  fill="#352389"
                />
                <path
                  id="Polygon_18"
                  data-name="Polygon 18"
                  d="M17.554,2.766a3,3,0,0,1,4.609,0L35.616,18.909a3,3,0,0,1-2.3,4.921H6.405a3,3,0,0,1-2.3-4.921Z"
                  transform="translate(1139.886 185.701)"
                  fill="#352389"
                />
              </g>
              <g id="Icon" transform="translate(-11465.344 -5233.955)">
                <rect
                  id="Area"
                  width="10"
                  height="10"
                  transform="translate(0.344 -0.045)"
                  fill="#352389"
                  opacity="0"
                />
                <g
                  id="Icon-2"
                  data-name="Icon"
                  transform="translate(0.341 -0.128)"
                >
                  <path
                    id="_549183a8-1a9e-4d3a-a743-6bc0bdc9a1ac"
                    data-name="549183a8-1a9e-4d3a-a743-6bc0bdc9a1ac"
                    d="M8.1,5.558V3.525A1.525,1.525,0,0,0,6.575,2L4.542,6.575v5.591h5.734a1.016,1.016,0,0,0,1.017-.864l.7-4.575a1.016,1.016,0,0,0-1.016-1.169ZM4.542,12.166H3.017A1.016,1.016,0,0,1,2,11.15V7.592A1.016,1.016,0,0,1,3.017,6.575H4.542"
                    transform="translate(-2 -2)"
                    fill="#352389"
                  />
                </g>
              </g>
              <g
                id="Icon-3"
                data-name="Icon"
                transform="translate(-10579.344 -5305.015)"
              >
                <rect
                  id="Area-2"
                  data-name="Area"
                  width="10"
                  height="10"
                  transform="translate(0.344 -0.045)"
                  fill="#352389"
                  opacity="0"
                />
                <g
                  id="Icon-4"
                  data-name="Icon"
                  transform="translate(0.341 -0.128)"
                >
                  <path
                    id="_549183a8-1a9e-4d3a-a743-6bc0bdc9a1ac-2"
                    data-name="549183a8-1a9e-4d3a-a743-6bc0bdc9a1ac"
                    d="M8.1,5.558V3.525A1.525,1.525,0,0,0,6.575,2L4.542,6.575v5.591h5.734a1.016,1.016,0,0,0,1.017-.864l.7-4.575a1.016,1.016,0,0,0-1.016-1.169ZM4.542,12.166H3.017A1.016,1.016,0,0,1,2,11.15V7.592A1.016,1.016,0,0,1,3.017,6.575H4.542"
                    transform="translate(-2 -2)"
                    fill="#352389"
                  />
                </g>
              </g>
              <path
                id="heart-svgrepo-com"
                d="M12.671,11.14a3.733,3.733,0,0,0-2.3-.806A5.519,5.519,0,0,0,7.1,11.624a5.519,5.519,0,0,0-3.272-1.29,3.733,3.733,0,0,0-2.3.806A3.513,3.513,0,0,0,0,14.076c.055,3.99,6.535,8.7,6.81,8.9l.286.206.286-.206c.276-.2,6.755-4.907,6.81-8.9A3.513,3.513,0,0,0,12.671,11.14Z"
                transform="translate(-11373.491 -5274.251)"
                fill="#352389"
              />
              <path
                id="heart-svgrepo-com-2"
                data-name="heart-svgrepo-com"
                d="M12.671,11.14a3.733,3.733,0,0,0-2.3-.806A5.519,5.519,0,0,0,7.1,11.624a5.519,5.519,0,0,0-3.272-1.29,3.733,3.733,0,0,0-2.3.806A3.513,3.513,0,0,0,0,14.076c.055,3.99,6.535,8.7,6.81,8.9l.286.206.286-.206c.276-.2,6.755-4.907,6.81-8.9A3.513,3.513,0,0,0,12.671,11.14Z"
                transform="translate(-10689.491 -5287.095)"
                fill="#352389"
              />
              <g
                id="Icon-5"
                data-name="Icon"
                transform="translate(-11332.71 -5315.501)"
              >
                <path
                  id="_59985621-b0d4-4242-97c8-27fb3607082b"
                  data-name="59985621-b0d4-4242-97c8-27fb3607082b"
                  d="M18,2H15a5,5,0,0,0-5,5v3H7v4h3v8h4V14h3l1-4H14V7a1,1,0,0,1,1-1h3Z"
                  transform="translate(-3.79 -4.499)"
                  fill="none"
                  stroke="#36219b"
                  strokeLineCap="round"
                  strokeLineJoin="round"
                  strokeWidth="2"
                />
              </g>
              <g
                id="Icon-6"
                data-name="Icon"
                transform="translate(-11415.71 -5214.501)"
              >
                <rect
                  id="b43cdabb-fc3c-42a3-9c91-4374c0dcde2c"
                  width="18"
                  height="18"
                  rx="5"
                  transform="translate(-1.29 -2.499)"
                  fill="none"
                  stroke="#36219b"
                  strokeLineCap="round"
                  strokeLineJoin="round"
                  strokeWidth="2"
                />
                <path
                  id="bb61490b-d6e1-4fca-a8f3-d7eb19e22bc7"
                  d="M15.2,11.029A3.6,3.6,0,1,1,12.171,8,3.6,3.6,0,0,1,15.2,11.029Z"
                  transform="translate(-3.894 -5.095)"
                  fill="none"
                  stroke="#36219b"
                  strokeLineCap="round"
                  strokeLineJoin="round"
                  strokeWidth="2"
                />
                <line
                  id="a80ddbf0-0cea-46ca-9582-adab961f8bc9"
                  x2="0.009"
                  transform="translate(12.66 1.551)"
                  fill="none"
                  stroke="#36219b"
                  strokeLineCap="round"
                  strokeLineJoin="round"
                  strokeWidth="2"
                />
              </g>
            </g>
          </svg>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            style={{ position: "absolute", bottom: "85px", right: "0px" }}
            width="198.172"
            height="164"
            viewBox="0 0 198.172 164"
          >
            <defs>
              <clipPath id="clip-path">
                <path
                  id="Path_84974"
                  data-name="Path 84974"
                  d="M2.5,0H195.668c1.382,0,2.5,5.373,2.5,12V152c0,6.627-1.121,12-2.5,12H2.5C1.121,164,0,158.627,0,152V12C0,5.373,1.121,0,2.5,0Z"
                  transform="translate(300 87)"
                  fill="#2f1a73"
                />
              </clipPath>
            </defs>
            <g
              id="Mask_Group_253"
              data-name="Mask Group 253"
              transform="translate(-300 -87)"
              clip-path="url(#clip-path)"
            >
              <path
                id="Path_84972"
                data-name="Path 84972"
                d="M81.252-51.208,76.368-34.04h10.8q7.7,0,7.7,8.14a9.49,9.49,0,0,1-2,6.438,7.15,7.15,0,0,1-5.7,2.294H71.484L68.672-7.7A12.666,12.666,0,0,1,64.306-1.11a10.5,10.5,0,0,1-6.438,2.294,7.69,7.69,0,0,1-5.328-2,7.085,7.085,0,0,1-2.22-5.55,13.512,13.512,0,0,1,.444-3.256l2.22-7.548H35.668L32.856-7.7A12.666,12.666,0,0,1,28.49-1.11a10.5,10.5,0,0,1-6.438,2.294,7.69,7.69,0,0,1-5.328-2,7.085,7.085,0,0,1-2.22-5.55,13.512,13.512,0,0,1,.444-3.256l2.22-7.548H12.876A7.381,7.381,0,0,1,7.1-19.462,9.266,9.266,0,0,1,5.032-25.9q0-4,2.072-6.068a7.8,7.8,0,0,1,5.772-2.072h9.176l5.032-17.168H18.8A7.381,7.381,0,0,1,13.024-53.5a9.266,9.266,0,0,1-2.072-6.438q0-4,2.072-6.068A7.8,7.8,0,0,1,18.8-68.08H31.968l2.812-9.768A11.19,11.19,0,0,1,39-84.286a10.959,10.959,0,0,1,6.438-2.146,8.785,8.785,0,0,1,5.7,1.85,6.042,6.042,0,0,1,2.294,4.958,8.381,8.381,0,0,1-.444,2.664l-2.516,8.88H67.784L70.6-77.848a11.19,11.19,0,0,1,4.218-6.438,10.959,10.959,0,0,1,6.438-2.146,8.785,8.785,0,0,1,5.7,1.85,6.042,6.042,0,0,1,2.294,4.958A8.381,8.381,0,0,1,88.8-76.96l-2.516,8.88h6.808q7.7,0,7.7,8.14a9.49,9.49,0,0,1-2,6.438,7.15,7.15,0,0,1-5.7,2.294Zm-18.352,0H45.436L40.552-34.04H57.868Z"
                transform="translate(400.513 281.382)"
                fill="#28135d"
                opacity="0.454"
              />
              <path
                id="Path_84973"
                data-name="Path 84973"
                d="M81.252-51.208,76.368-34.04h10.8q7.7,0,7.7,8.14a9.49,9.49,0,0,1-2,6.438,7.15,7.15,0,0,1-5.7,2.294H71.484L68.672-7.7A12.666,12.666,0,0,1,64.306-1.11a10.5,10.5,0,0,1-6.438,2.294,7.69,7.69,0,0,1-5.328-2,7.085,7.085,0,0,1-2.22-5.55,13.512,13.512,0,0,1,.444-3.256l2.22-7.548H35.668L32.856-7.7A12.666,12.666,0,0,1,28.49-1.11a10.5,10.5,0,0,1-6.438,2.294,7.69,7.69,0,0,1-5.328-2,7.085,7.085,0,0,1-2.22-5.55,13.512,13.512,0,0,1,.444-3.256l2.22-7.548H12.876A7.381,7.381,0,0,1,7.1-19.462,9.266,9.266,0,0,1,5.032-25.9q0-4,2.072-6.068a7.8,7.8,0,0,1,5.772-2.072h9.176l5.032-17.168H18.8A7.381,7.381,0,0,1,13.024-53.5a9.266,9.266,0,0,1-2.072-6.438q0-4,2.072-6.068A7.8,7.8,0,0,1,18.8-68.08H31.968l2.812-9.768A11.19,11.19,0,0,1,39-84.286a10.959,10.959,0,0,1,6.438-2.146,8.785,8.785,0,0,1,5.7,1.85,6.042,6.042,0,0,1,2.294,4.958,8.381,8.381,0,0,1-.444,2.664l-2.516,8.88H67.784L70.6-77.848a11.19,11.19,0,0,1,4.218-6.438,10.959,10.959,0,0,1,6.438-2.146,8.785,8.785,0,0,1,5.7,1.85,6.042,6.042,0,0,1,2.294,4.958A8.381,8.381,0,0,1,88.8-76.96l-2.516,8.88h6.808q7.7,0,7.7,8.14a9.49,9.49,0,0,1-2,6.438,7.15,7.15,0,0,1-5.7,2.294Zm-18.352,0H45.436L40.552-34.04H57.868Z"
                transform="translate(397.384 260.432)"
                fill="#36219b"
              />
              <g id="Icon" transform="translate(326.462 209.499)">
                <path
                  id="bcfcb8dc-eb9c-4b2e-8764-4af6e12f9db1"
                  d="M20.909,2.727a9.9,9.9,0,0,1-2.854,1.391,4.073,4.073,0,0,0-7.146,2.727v.91A9.691,9.691,0,0,1,2.727,3.636S-.909,11.818,7.273,15.455A10.59,10.59,0,0,1,.909,17.273c8.182,4.545,18.182,0,18.182-10.455a4.056,4.056,0,0,0-.073-.754A7.017,7.017,0,0,0,20.909,2.727Z"
                  transform="translate(-2.199 -3.373)"
                  fill="none"
                  stroke="#36219b"
                  strokeLineCap="round"
                  strokeLineJoin="round"
                  strokeWidth="1.818"
                />
              </g>
              <path
                id="heart-svgrepo-com"
                d="M12.671,11.14a3.733,3.733,0,0,0-2.3-.806A5.519,5.519,0,0,0,7.1,11.624a5.519,5.519,0,0,0-3.272-1.29,3.733,3.733,0,0,0-2.3.806A3.513,3.513,0,0,0,0,14.076c.055,3.99,6.535,8.7,6.81,8.9l.286.206.286-.206c.276-.2,6.755-4.907,6.81-8.9A3.513,3.513,0,0,0,12.671,11.14Z"
                transform="translate(353.68 140.905)"
                fill="#352389"
              />
              <g
                id="Icon-2"
                data-name="Icon"
                transform="translate(400.462 114.499)"
              >
                <path
                  id="_19b38688-488b-468d-970f-ea8125e5faa1"
                  data-name="19b38688-488b-468d-970f-ea8125e5faa1"
                  d="M16,8a6,6,0,0,1,6,6v7H18V14a2,2,0,0,0-4,0v7H10V14A6,6,0,0,1,16,8Z"
                  transform="translate(-3.29 -3.999)"
                  fill="none"
                  stroke="#36219b"
                  strokeLineCap="round"
                  strokeLineJoin="round"
                  strokeWidth="1.5"
                />
                <rect
                  id="b062cfcc-ce9b-460f-9815-ecb8428ca49d"
                  width="4"
                  height="12"
                  transform="translate(-1.29 5.001)"
                  fill="none"
                  stroke="#36219b"
                  strokeLineCap="round"
                  strokeLineJoin="round"
                  strokeWidth="1.5"
                />
                <circle
                  id="_97d2c605-a5f5-49dc-b1ab-5b08687c78e8"
                  data-name="97d2c605-a5f5-49dc-b1ab-5b08687c78e8"
                  cx="2"
                  cy="2"
                  r="2"
                  transform="translate(-1.29 -1.999)"
                  fill="none"
                  stroke="#36219b"
                  strokeLineCap="round"
                  strokeLineJoin="round"
                  strokeWidth="1.5"
                />
              </g>
              <g
                id="Icon-3"
                data-name="Icon"
                transform="translate(463.828 122.985)"
              >
                <rect
                  id="Area"
                  width="10"
                  height="10"
                  transform="translate(0.344 -0.045)"
                  fill="#352389"
                  opacity="0"
                />
                <g
                  id="Icon-4"
                  data-name="Icon"
                  transform="translate(0.341 -0.128)"
                >
                  <path
                    id="_549183a8-1a9e-4d3a-a743-6bc0bdc9a1ac"
                    data-name="549183a8-1a9e-4d3a-a743-6bc0bdc9a1ac"
                    d="M8.1,5.558V3.525A1.525,1.525,0,0,0,6.575,2L4.542,6.575v5.591h5.734a1.016,1.016,0,0,0,1.017-.864l.7-4.575a1.016,1.016,0,0,0-1.016-1.169ZM4.542,12.166H3.017A1.016,1.016,0,0,1,2,11.15V7.592A1.016,1.016,0,0,1,3.017,6.575H4.542"
                    transform="translate(-2 -2)"
                    fill="#352389"
                  />
                </g>
              </g>
            </g>
          </svg>
        </BgDiv>
        <ContentDiv>
          <ContentWrap>
            <LCont>
              <img
                src={`${webUrl}/assets/images/brandassets/darkBg.png`}
                alt="Picmaker"
              ></img>
            </LCont>
            <TCont>
              <Btxt>
                <SplText>The Future Of Social Space</SplText>
                <div>is getting redefined with Picmaker</div>
              </Btxt>
              <Stxt>
                Join us at the Picmaker Social Summit 2022 as we unveil new
                possibilities for you to conquer social space
              </Stxt>
            </TCont>
            <FooterDiv>
              <SButton
                href={`${webUrl}/social-summit-2022?utm_source=Website&utm_medium=Templates&utm_campaign=Picmakersocialsummit`}
                target="_blank"
              >
                Save me a seat!
              </SButton>
            </FooterDiv>
          </ContentWrap>
        </ContentDiv>
        <CloseBtn
          onClick={(e) => {
            props.handleCloseFeatureAlert();
          }}
        >
          <svg id="Layer_1" data-name="Layer 1" viewBox="0 0 24 24">
            <g className="cls-2">
              <path
                className="cls-4"
                d="M14.6,10.6,13.2,12l1.3,1.3c.2.2.2.4,0,.5l-.7.7c-.2.2-.4.2-.5,0L12,13.2l-1.4,1.4c-.2.2-.4.2-.5,0l-.7-.7c-.2-.2-.2-.4,0-.5L10.8,12,9.5,10.7c-.2-.2-.2-.4,0-.5l.7-.7c.2-.2.4-.2.5,0L12,10.8l1.4-1.4c.2-.2.4-.2.5,0l.6.6A.47.47,0,0,1,14.6,10.6Z"
                fill="#fff"
              />
            </g>
          </svg>
        </CloseBtn>
      </FeatureDiv>
    </Wrapper>
  );
}
